import React from 'react';

const WidgetSettingsFooter = ({
  t,
  onCancel,
  onSave,
}) => (
  <div className='modal-footer' style={{ backgroundColor: 'var(--header-background)' }}>
    <button className='btn btn-cancel' onClick={onCancel}>{t.cancel}</button>
    <button className='btn btn-apply' onClick={onSave}>{t.save}</button>
  </div>
);

export default WidgetSettingsFooter;
